export default __webpack_public_path__ + "static/media/portfolio-200.0a51a207.jpg";